import React, { useState, useEffect } from 'react';
import { Box, useTheme, Button, Grid } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { useAuth } from "../../components/AuthContext";
import { ArrowCircleRightOutlined } from '@mui/icons-material';
import { format } from 'date-fns';

const Horas = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const { userInfo } = useAuth();
  const [horasTrabalhadas, setHorasTrabalhadas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://pf-auditores.ew.r.appspot.com/api/horas-trabalhadas");
        const horasData = response.data;
  
        let horasDataUsuarioLogado;      
  
        if (userInfo.tipo === 'BASICO') {
          // Filtra as horas do usuário logado
          horasDataUsuarioLogado = horasData.filter(hora => hora.colaboradorId === userInfo.id);
        } else {
          // Lista todas as horas para usuários do tipo EDITOR e ADMIN
          horasDataUsuarioLogado = horasData;
        }
  
        const clientesMap = {};
        const clientesResponse = await axios.get('https://pf-auditores.ew.r.appspot.com/api/clientes');
        clientesResponse.data.forEach(cliente => {
          clientesMap[cliente.id] = cliente.nomeCliente;
        });
  
        const colaboradoresResponse = await axios.get('https://pf-auditores.ew.r.appspot.com/api/colaboradores');
        const colaboradoresMap = colaboradoresResponse.data.reduce((acc, colaborador) => {
          acc[colaborador.id] = colaborador.nome;
          return acc;
        }, {});
  
        const monthNames = [
          "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
          "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];
  
        const horasDataEnriched = horasDataUsuarioLogado.map(hora => ({
          ...hora,
          nomeColaborador: colaboradoresMap[hora.colaboradorId] || 'Desconhecido',
          nomeCliente: clientesMap[hora.clienteId] || 'Desconhecido',
          mes: monthNames[new Date(hora.dia1Data).getMonth()],
        }));
  
        // Ordena as horas para listar "Pendente" primeiro e em ordem decrescente por data
        horasDataEnriched.sort((a, b) => {
          if (a.estado === 'Pendente' && b.estado !== 'Pendente') return -1;
          if (a.estado !== 'Pendente' && b.estado === 'Pendente') return 1;
          return new Date(b.dia1Data) - new Date(a.dia1Data);
        });
  
        setHorasTrabalhadas(horasDataEnriched);
  
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [userInfo]);
  

  const columns = [
    {
      field: "dia1Data",
      headerName: "Data",
      flex: 1,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
      },
    },
    {
      field: "nomeColaborador",
      headerName: "Nome do Colaborador",
      flex: 1,
    },
    {
      field: "nomeCliente",
      headerName: "Cliente",
      flex: 1,
    },
    {
      field: "mes",
      headerName: "Mês",
      flex: 1,
    },
    {
      field: "totalHoras",
      headerName: "Total de Horas",
      flex: 1,
    },
    {
      field: "estado",
      headerName: "Estado",
      flex: 1,
    },
    {
      field: "ver",
      headerName: "",
      flex: 0.5,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<ArrowCircleRightOutlined />}
            onClick={() => navigate(`/horas/editar/${params.row.id}`)}
          >
            Ver
          </Button>
        );
      },
    },
  ];

  return (
    <Box m="20px">
      <Header title="Folha de Horas" subtitle="Lista de folhas de horas registadas" />
      <Grid container justifyContent="space-between" marginBottom="20px">
        <Grid item>
          <Button variant="contained" color="primary" onClick={() => navigate('/horas/registar')}>
            Adicionar horas trabalhadas
          </Button>
        </Grid>
        <Grid item>
          {/* Este Grid item é para manter os filtros */}
          {/* Adicione aqui os componentes de filtro, se necessário */}
        </Grid>
      </Grid>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={horasTrabalhadas}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          loading={loading}
        />
      </Box>
    </Box>
  );
};

export default Horas;
